// src/app/models/transaction-item.model.ts
export interface TransactionItem {
  itemID: number;
  foreignItemID: number;
  requestNote?: string;
  responseNote?: string;
  quantity: number;
  proposedUnitPrice?: number;
  proposedTotal?: number;
  status: ApproveItemStatus;
  imageUrl?: string;
}

export enum ApproveItemStatus {
  None     = 0,
  Pending  = 1,
  Approved = 2,
  Done     = 3,
  Declined = 10
}
